import type { Patch } from "@freightsimple/shared/types";
import type { ErrorMessageType } from "@freightsimple/ui-core/FormLayout/FormItem";
import type { Address } from "@freightsimple/generated-dashboard-openapi-client/models/Address";
import type { PreQuoteLocation } from "@freightsimple/generated-dashboard-openapi-client/models/PreQuoteLocation";
import { locationsErrorMessageForPostalCode } from "./locationsErrorMessageForPostalCode";
import { locationsErrorMessageForRequiredField } from "./locationsErrorMessageForRequiredField";
import { isSimilar } from "@/Helpers/isSimilar";

export interface AddressErrors {
  addressLine: ErrorMessageType;
  addressLine2: ErrorMessageType;
  city: ErrorMessageType;
  postalCode: ErrorMessageType;
  stateOrProvinceCode: ErrorMessageType;
  country: ErrorMessageType;
}

export function errorMessageForAddressLine1(
  addressLine1: string | undefined,
  pickupLocation?: PreQuoteLocation,
  deliveryLocation?: PreQuoteLocation,
): ErrorMessageType {
  if (addressLine1 === undefined || addressLine1 === "") {
    return "Required";
  }

  // Check for duplicate addresses with specific messages
  if (
    pickupLocation &&
    isSimilar(addressLine1, pickupLocation.address.addressLine)
  ) {
    return "Should not match pickup details";
  }

  if (
    deliveryLocation &&
    isSimilar(addressLine1, deliveryLocation.address.addressLine)
  ) {
    return "Should not match delivery details";
  }

  return undefined;
}

export function locationsErrorMessagesForAddress(
  address: Patch<Address>,
  pickupLocation?: PreQuoteLocation,
  deliveryLocation?: PreQuoteLocation,
): AddressErrors {
  return {
    addressLine: errorMessageForAddressLine1(
      address.addressLine,
      pickupLocation,
      deliveryLocation,
    ),
    addressLine2: undefined,
    city: locationsErrorMessageForRequiredField(address.city),
    stateOrProvinceCode: locationsErrorMessageForRequiredField(
      address.stateOrProvinceCode,
    ),
    postalCode: locationsErrorMessageForPostalCode(
      address.postalCode,
      address.city,
    ),
    country: locationsErrorMessageForRequiredField(address.countryCode),
  };
}
